import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SecureIcon = (props: any) => (
  <Svg
    width={props?.width || 12}
    height={props?.height || 12}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    size={12}
    color="#109648FF"
    {...props}
  >
    <Path
      d="M7.317 8.783L6 7.467a.499.499 0 00-.367-.15.499.499 0 00-.366.15c-.1.1-.15.222-.15.366 0 .145.05.267.15.367l1.65 1.65c.1.1.22.15.358.15a.49.49 0 00.358-.15l3.084-3.083a.473.473 0 00.133-.35.473.473 0 00-.133-.35.463.463 0 00-.342-.134.463.463 0 00-.342.134L7.317 8.783zM8 14.617a.879.879 0 01-.125-.009.624.624 0 01-.108-.025c-1.49-.444-2.711-1.358-3.667-2.741-.956-1.384-1.433-2.903-1.433-4.559V4.017a.97.97 0 01.183-.575c.122-.173.278-.298.467-.375L7.65 1.45c.122-.044.239-.067.35-.067.111 0 .228.023.35.067l4.333 1.617c.19.077.345.202.467.375a.97.97 0 01.183.575v3.266c0 1.656-.477 3.175-1.433 4.559-.956 1.383-2.178 2.297-3.667 2.741L8 14.617zm0-1c1.278-.423 2.32-1.22 3.125-2.392.806-1.172 1.208-2.486 1.208-3.942V4.017L8 2.383 3.667 4.017v3.266c0 1.456.402 2.77 1.208 3.942.806 1.172 1.847 1.97 3.125 2.392z"
      fill="#109648FF"
    />
  </Svg>
);
export default SecureIcon;
